import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Star } from "lucide-react";

const RATING_LABELS = {
  0: "Sélectionnez une note",
  1: "Très mauvais",
  2: "Mauvais",
  3: "Moyen",
  4: "Bien",
  5: "Excellent !",
};

// Carte de notation du livreur (avant & après soumission)
export default function CourierRatingCard({
  courierName,
  showRating,
  ratingScore,
  ratingComment,
  submittingRating,
  onOpenRating,
  onScoreChange,
  onCommentChange,
  onSubmit,
  onCancel,
}) {
  return (
    <Card className="bg-[#0F172A] border-2 border-[#D4AF37] shadow-2xl shadow-yellow-900/20 rounded-2xl" data-testid="rating-card">
      <CardContent className="pt-6 pb-6">
        {!showRating ? (
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-3 rounded-2xl bg-gradient-to-br from-[#D4AF37] to-[#B8962E] flex items-center justify-center shadow-lg">
              <Star className="w-8 h-8 text-[#0F172A] fill-current" />
            </div>
            <h3 className="text-lg font-black text-white mb-2 uppercase tracking-tight">Comment s'est passée la livraison ?</h3>
            <p className="text-sm text-slate-300 font-medium mb-5">
              Notez <span className="text-[#D4AF37] font-black">{courierName}</span> pour cette commande
            </p>
            <Button
              onClick={onOpenRating}
              className="bg-[#D4AF37] hover:bg-[#B8962E] text-[#0F172A] rounded-full px-8 font-black text-xs uppercase tracking-widest shadow-lg shadow-yellow-500/30"
              data-testid="open-rating-btn"
            >
              <Star className="w-4 h-4 mr-2" />
              Noter le livreur
            </Button>
          </div>
        ) : (
          <div className="space-y-4">
            <h3 className="text-lg font-black text-white text-center uppercase tracking-tight">
              Noter {courierName}
            </h3>

            {/* Star selection */}
            <div className="flex justify-center gap-3" data-testid="star-selector">
              {[1, 2, 3, 4, 5].map((s) => (
                <button
                  key={s}
                  onClick={() => onScoreChange(s)}
                  className="transition-transform hover:scale-125"
                  data-testid={`star-${s}`}
                >
                  <Star
                    className={`w-10 h-10 ${s <= ratingScore ? 'text-[#D4AF37] fill-[#D4AF37]' : 'text-slate-600'}`}
                  />
                </button>
              ))}
            </div>
            <p className="text-center text-sm text-white font-bold uppercase tracking-widest">
              {RATING_LABELS[ratingScore]}
            </p>

            {/* Comment */}
            <div>
              <textarea
                value={ratingComment}
                onChange={(e) => onCommentChange(e.target.value)}
                placeholder="Commentaire optionnel..."
                className="w-full h-20 rounded-xl border border-gray-200 px-4 py-3 text-sm resize-none focus:ring-2 focus:ring-yellow-400 focus:border-transparent"
                data-testid="rating-comment"
              />
            </div>

            <div className="flex gap-3">
              <Button
                onClick={onSubmit}
                disabled={ratingScore < 1 || submittingRating}
                className="flex-1 bg-yellow-500 hover:bg-yellow-600 text-white rounded-full"
                data-testid="submit-rating-btn"
              >
                {submittingRating ? "Envoi..." : "Envoyer la note"}
              </Button>
              <Button
                onClick={onCancel}
                variant="outline"
                className="rounded-full"
              >
                Annuler
              </Button>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
